// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 725 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"548":"3bfc46af","667":"8d0d3490","725":"81f952d4","880":"ee81609c","977":"312e4bef"}[chunkId] + ".chunk.js";
};